import React from 'react';

const PencilIcon = ({
    width = 40,
    height = 40,
    fill = 'none',
    stroke = 'black',
    className = '',
}) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 40 40"
            fill={fill}
            className={className}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M21.6668 11.6667L14.5002 4.50004C13.7475 3.75096 12.7287 3.33044 11.6668 3.33044C10.6049 3.33044 9.5862 3.75096 8.83349 4.50004L4.50016 8.83337C3.75109 9.58607 3.33057 10.6048 3.33057 11.6667C3.33057 12.7286 3.75109 13.7473 4.50016 14.5L11.6668 21.6667M13.3335 10L16.6668 6.6667M30.0002 26.6667L33.3335 23.3334M28.3335 18.3334L35.5002 25.5C37.0668 27.0667 37.0668 29.6 35.5002 31.1667L31.1668 35.5C29.6002 37.0667 27.0668 37.0667 25.5002 35.5L18.3335 28.3334M25.0002 8.33337L31.6668 15M35.2902 11.3534C36.1713 10.4724 36.6665 9.27748 36.6666 8.03146C36.6668 6.78544 36.172 5.59038 35.291 4.7092C34.41 3.82802 33.2151 3.33289 31.9691 3.33273C30.7231 3.33258 29.528 3.82741 28.6468 4.70837L6.40349 26.9567C6.01652 27.3425 5.73035 27.8176 5.57016 28.34L3.36849 35.5934C3.32542 35.7375 3.32216 35.8906 3.35908 36.0365C3.39599 36.1823 3.47169 36.3154 3.57815 36.4217C3.68461 36.528 3.81786 36.6035 3.96376 36.6402C4.10965 36.6768 4.26276 36.6733 4.40683 36.63L11.6618 34.43C12.1838 34.2713 12.6588 33.9869 13.0452 33.6017L35.2902 11.3534Z"
                stroke={stroke}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default PencilIcon;
